import { $pageId } from './share';
export default {
    pageView: function (options) {
        var json = {
            pageId: options.pageId,
            pageData: options.pageData || ''
        };
        if (typeof json.pageData === 'object') {
            json.pageData = JSON.stringify(json.pageData);
        }
        console.info('调用客户端页面统计：', json);
        if (window.goods && window.goods.setAnalysisPageId) {
            window.goods && window.goods.setAnalysisPageId(JSON.stringify(json));
        }
    },
    click: function (options) {
        var pageId = options.pageId || $pageId;
        var eventId = options.eventId;
        if (eventId.indexOf(pageId) !== 0) {
            eventId = pageId + ":" + eventId;
        }
        var eventData = options.eventData || '';
        if (typeof eventData === 'object') {
            eventData = JSON.stringify(eventData);
        }
        var json = {
            eventId: eventId,
            pageId: pageId,
            eventData: eventData
        };
        console.info('调用客户端事件统计：', json);
        if (window.goods && window.goods.addEventRecord) {
            window.goods && window.goods.addEventRecord(JSON.stringify(json));
        }
    }
};
//# sourceMappingURL=nativeLog.js.map